import { defineStore } from 'pinia'

const useLawyerStore = defineStore('lawyer', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useLawyerStore
